import {
  FileExcelOutlined,
  FilePdfOutlined,
  FilePptOutlined,
  FileTextOutlined,
  FileUnknownOutlined,
  FileWordOutlined,
} from '@ant-design/icons'
import React from 'react'

export const FileViewer = ({
  file,
  style,
  onClick = () => {},
  showCaption = false,
}) => {
  const { type, caption } = file || {}
  let IconType = FileUnknownOutlined
  if (type) {
    if (type.includes('text')) IconType = FileTextOutlined
    else if (type.includes('pdf')) IconType = FilePdfOutlined
    else if (type.includes('sheet')) IconType = FileExcelOutlined
    else if (type.includes('presentation')) IconType = FilePptOutlined
    else if (type.includes('document')) IconType = FileWordOutlined
  }
  return (
    <div className="asset-file-viewer" style={style} onClick={onClick}>
      <IconType />
      {showCaption && <div title={caption}>{caption}</div>}
    </div>
  )
}
